var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditableIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D0A2",
    d: "m9.326 2.499 3.05 3.05-7.722 7.723-3.049-3.05zm5.365-.736-1.36-1.36a1.35 1.35 0 0 0-1.907 0L10.12 1.706l3.051 3.05 1.52-1.52a1.04 1.04 0 0 0 0-1.473M.01 14.51c-.056.25.17.474.42.413l3.399-.824-3.049-3.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditableIconGreen);
export default __webpack_public_path__ + "static/media/editable-icon-green.5c026b7c72ac00f07f878837e6e1d7ab.svg";
export { ForwardRef as ReactComponent };